import "./buttonSolid.scss";
//
import classNames from "classnames";
import { Link } from "react-router-dom";

export interface ButtonSolidType {
  className?: string;
  href?: string;
  label: string;
  onClick?: () => void;
  to?: string;
  glow?: boolean;
}

const ButtonSolid: React.FC<ButtonSolidType> = (props) => {
  const classNamesComb = classNames("buttonSolid", props.className, {
    "has-glow": props.glow,
  });

  if (!!props.to) {
    return (
      <Link to={props.to} className={classNamesComb}>
        {props.label}
      </Link>
    );
  }

  if (!!props.onClick) {
    return (
      <button onClick={props.onClick} className={classNamesComb}>
        {props.label}
      </button>
    );
  }

  return (
    <a
      href={props.href || "#"}
      target="_blank"
      rel="noreferrer"
      className={classNamesComb}
    >
      {props.label}
    </a>
  );
};

export default ButtonSolid;
